/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding startup/initialization code.
 * Use "quasar new boot <name>" and add it there.
 * One boot file per concern. Then reference the file(s) in quasar.conf.js > boot:
 * boot: ['file', ...] // do not add ".js" extension to it.
 *
 * Boot files are your "main.js"
 **/



import {Notify} from 'quasar'



export default { config: {"brand":{"primary":"rgb(18,166,80)","secondary":"rgb(5,47,95)","accent":"rgb(242,192,55)","dark":"#1d1d1d","positive":"#21BA45","negative":"rgb(255,0,0)","info":"rgb(0,186,255)","warning":"rgb(242,192,55)"},"notify":{}},plugins: {Notify} }

